import {Component, OnInit, ViewChild} from '@angular/core';
import {LoadingService} from '../services/loading.service';
import {MatTabGroup} from '@angular/material';

import LoadingOrdersConfig from '../table/configs/loading_orders.json';

@Component({
  styleUrls: ['./loading-orders.component.scss'],
  templateUrl: './loading-orders.component.html'
})
export class LoadingOrdersComponent implements OnInit {
  public config: any;
  public initializePage: boolean;
  public OrdersToBeExecutedConfig: any;
  public OrdersToBeSentConfig: any;
  public OrdersSentConfig: any;
  public OrdersCancelConfig: any;

  public show0: boolean;
  public show1: boolean;
  public show2: boolean;
  public show3: boolean;

  @ViewChild('tabs', {static: false}) tabs: MatTabGroup;

  constructor(private loadingService: LoadingService) {
    this.OrdersToBeExecutedConfig = (JSON.parse(JSON.stringify(LoadingOrdersConfig)));
    this.OrdersToBeExecutedConfig.filter = 'command_type=0 AND (status_id=1 OR command_details_total_quantity<>material_ex_total AND status_id NOT IN (9,4))';
    this.OrdersToBeExecutedConfig.nested = true;
    this.OrdersToBeSentConfig = (JSON.parse(JSON.stringify(LoadingOrdersConfig)));
    this.OrdersToBeSentConfig.filter = 'command_type = 0 AND status_id <> 9 AND stage_id = 2';
    this.OrdersToBeSentConfig.nested = true;

    this.OrdersSentConfig = (JSON.parse(JSON.stringify(LoadingOrdersConfig)));
    this.OrdersSentConfig.filter = 'command_type = 0 AND status_id <> 9 AND stage_id = 3';
    this.OrdersSentConfig.nested = true;


    this.OrdersCancelConfig = (JSON.parse(JSON.stringify(LoadingOrdersConfig)));
    this.OrdersCancelConfig.filter = 'command_type = 0 AND status_id = 9';

    this.config = {
      title: 'Εντολές Φόρτωσης',
      model: 'loading_orders',
      nested: true
    };

    this.show0 = true;
    this.show1 = false;
    this.show2 = false;
    this.show3 = false;
  }


  public changeTab(tabs: MatTabGroup): void {
    if (tabs.selectedIndex === 0) {
      this.show0 = true;
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
    }
    if (tabs.selectedIndex === 1) {
      this.show0 = false;
      this.show1 = true;
      this.show2 = false;
      this.show3 = false;
    }
    if (tabs.selectedIndex === 2) {
      this.show0 = false;
      this.show1 = false;
      this.show2 = true;
      this.show3 = false;
    }

    if (tabs.selectedIndex === 3) {
      this.show0 = false;
      this.show1 = false;
      this.show2 = false;
      this.show3 = true;
    }
  }

  public show(tabs: MatTabGroup): number {
    return tabs.selectedIndex;
  }

  public ngOnInit(): void {
    this.initializePage = true;
    this.loadingService.hide();
  }
}
